import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "cloud-upload" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.19868 6.12364C5.01446 4.28431 6.8564 3 9 3C11.6678 3 13.8708 4.98986 14.2059 7.56634C15.9395 7.89655 17.25 9.42023 17.25 11.25C17.25 13.3211 15.5711 15 13.5 15H12C11.5858 15 11.25 14.6642 11.25 14.25C11.25 13.8358 11.5858 13.5 12 13.5H13.5C14.7426 13.5 15.75 12.4926 15.75 11.25C15.75 10.0074 14.7426 9 13.5 9C13.0858 9 12.75 8.66421 12.75 8.25C12.75 6.17893 11.0711 4.5 9 4.5C7.35788 4.5 5.96045 5.55594 5.45337 7.02807C5.36104 7.29613 5.12544 7.48921 4.84446 7.52709C3.37968 7.72455 2.25 8.98097 2.25 10.5C2.25 12.1569 3.59315 13.5 5.25 13.5H6C6.41421 13.5 6.75 13.8358 6.75 14.25C6.75 14.6642 6.41421 15 6 15H5.25C2.76472 15 0.75 12.9853 0.75 10.5C0.75 8.37645 2.22031 6.59739 4.19868 6.12364ZM6.59467 10.3447L8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L11.4053 10.3447C11.6982 10.6376 11.6982 11.1124 11.4053 11.4053C11.1124 11.6982 10.6376 11.6982 10.3447 11.4053L9.75 10.8107V14.25C9.75 14.6642 9.41421 15 9 15C8.58579 15 8.25 14.6642 8.25 14.25V10.8107L7.65533 11.4053C7.36244 11.6982 6.88756 11.6982 6.59467 11.4053C6.30178 11.1124 6.30178 10.6376 6.59467 10.3447Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }